import wrapInObserver from '../../wrapInObserver';
import ActiveTransporterBanner from './ActiveTransporterBanner';
import ActiveTransporterBannerMobile from './ActiveTransporterBannerMobile';
import logger from '../../../logger';
import generatedHooks from '../../../hooks/generatedHooks';

import { makeActiveTransporterUrl } from '../../../utils/urlProvider';
import BannerStore from '../../../stores/bannerStore';

const { useBannerStore } = generatedHooks;

const mapProps = () => {
  try {
    const bannerStore = useBannerStore(store => store);

    return {
      activeTransporterUrl: makeActiveTransporterUrl(),
      closeBanner: bannerStore.putTransporterBannerViewedFlag,
      imageUrl: bannerStore.banners[BannerStore.BANNER_TYPES.TRANSPORTER].imageUrl,
    };
  } catch (error) {
    logger.error(error, { sentryMessage: 'Error while rendering ActiveTransporterBanner' });
    return {};
  }
};

export default wrapInObserver(ActiveTransporterBanner, mapProps, ActiveTransporterBannerMobile);
